export default angular
  .module('doxy.realtime.components.groupCall.services.groupCallService', [])
  .service('groupCallService', function ($rootScope) {
    return {
      getMaxPatientsCount() {
        if ($rootScope.globalState.beta['25peopleCall']) return 24;
        return 11;
      },
    };
  }).name;
